function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M903.196427 392.196055H29.785212A29.729093 29.729093 0 0 1 0.000062 362.410905V253.19246a29.729093 29.729093 0 0 1 29.78515-29.78515h873.411215a29.729093 29.729093 0 0 1 29.78515 29.78515v109.068959a29.897265 29.897265 0 0 1-29.78515 29.897264zM51.834445 340.212186h829.462236v-65.082608H51.834445z m0 0",
  "p-id": 9394
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M823.46416 923.657306H113.161209A30.98104 30.98104 0 0 1 82.21754 892.694951V370.726082a30.98104 30.98104 0 0 1 30.962355-30.943669h710.284265a30.98104 30.98104 0 0 1 30.962354 30.943669v521.838068a31.093155 31.093155 0 0 1-30.962354 31.093156z m-689.505666-51.834383h668.633638v-480.224813H134.033237z m0 0",
  "p-id": 9395
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M617.602807 633.392237h-284.024015a28.327658 28.327658 0 0 1-28.308972-28.308972v-99.034689a28.346344 28.346344 0 0 1 28.308972-28.327658h284.024015a28.36503 28.36503 0 0 1 28.327658 28.327658v99.034689a28.458459 28.458459 0 0 1-28.327658 28.308972zM357.272375 581.576541h236.674221v-51.703582H357.272375z m-165.425303-313.043047l-45.836244-24.384957L250.389654 47.331107a89.075163 89.075163 0 0 1 120.317804-36.941808l336.830058 178.785643a90.158939 90.158939 0 0 1 36.792321 36.792321l-45.836244 24.291528a36.867064 36.867064 0 0 0-15.341034-15.322348L346.471988 56.244229a36.698892 36.698892 0 0 0-28.327658-2.634696 37.222094 37.222094 0 0 0-21.899747 17.957044z m0 0",
  "p-id": 9396
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M739.07913 241.812814l-20.722542-85.562235a37.203409 37.203409 0 0 0-44.845896-27.299939l-119.1406 28.906917-12.127078-50.451634L661.477042 78.573749a89.149906 89.149906 0 0 1 107.461981 65.400266l20.741227 85.562234zM428.371807 91.859346l45.85493 24.291527-83.525483 157.240926-45.836244-24.384956z m-101.613328 0.298972l40.30525 21.469973L345.687185 153.914856l-40.30525-21.451288z m-41.463769 77.975804l40.286564 21.451287-21.451287 40.30525-40.30525-21.469973z m0 0",
  "p-id": 9397
});

function SvgSecondhand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1632807202042,
    className: "icon",
    viewBox: "0 0 1315 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 9393,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256.8359375,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondhand);
export default __webpack_public_path__ + "static/media/secondhand.20cd74a9.svg";
export { ForwardRef as ReactComponent };